// extracted by mini-css-extract-plugin
export var label = "_am-1";
export var reminder = "_am-0";